import { PrimaryRecordMedication } from './MedicalDataTypes';

export const LIMITS = Object.freeze({
    groups: 20,
    candidatesPerGroup: 100,
    candidates: 500,
    pageSize: 25,
    seedRecords: 300,
    additionsPerGroup: 3,
    additions: 40,
    contextBytes: 32 * 1024,
    instructionCharacters: 2000,
});

export type GroupCandidates = {
    groupId: string;
    seedIds: string[];
    candidates: { id: string; isPrimary: boolean }[];
    totalRecords: number;
    inspectionLimited: boolean;
};

export type GroupSearchResult = {
    groups: GroupCandidates[];
    unresolvedSeedIds: string[];
    groupsLimited: boolean;
};

export type SourceEvidence = {
    source: string;
    institution?: string;
    sourceDate?: string;
    sourceStatus?: string;
    intent?: string;
    reported?: boolean;
    overriddenFields: string[];
    instructions: { step: number; text: string }[];
    instructionsTruncated: boolean;
};

export type MedicationEvidence = {
    medication: PrimaryRecordMedication;
    evidence: SourceEvidence;
};

/** References only records actually included in the chat context. */
export type GroupContext<TId = string> = {
    includedResourceIds: TId[];
    primaryResourceId?: TId;
    totalRecords: number;
    inspectedRecords: number;
    inspectionLimited: boolean;
    selectionLimited: boolean;
};

export type Context<TId = string> = {
    groups: GroupContext<TId>[];
    limited: boolean;
    unavailable?: boolean;
};
